
























import { Component, Mixins, Prop } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import { AddressModel } from '@/interfaces/registration/models/AddressModel';
import { ListOption } from '@/interfaces/registration/ListOption';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

@Component
export default class AddressEditor extends Mixins(FormFieldMixin) {
  @Prop({ default: () => { return {}; } }) readonly value!: AddressModel;

  public _model: AddressModel = {};

  get model (): AddressModel {
    this._model = this.value;
    return this._model;
  };

  @utils.State
  public states!: Array<ListOption>;

  @utils.State
  public countries!: Array<ListOption>;

  public valueChanged (): void {
    this.$emit('input', this._model);
  }
}
